import { render, staticRenderFns } from "./SkirmishesItemInformation.vue?vue&type=template&id=244ae9cb&"
import script from "./SkirmishesItemInformation.vue?vue&type=script&lang=js&"
export * from "./SkirmishesItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports